<form [formGroup]="productForm">
  <h2 mat-dialog-title>
    <i class="fa fa-floppy-disk" aria-hidden="true"></i>&nbsp; {{title}}
  </h2>
  <div mat-dialog-content gdGap="15px">
    <div gdColumns="repeat(2, minmax(0, 1fr))" gdGap="15px">
      <mat-form-field gdColumn="span 2">
        <mat-label>Name</mat-label>
        <input matInput autocomplete="off" formControlName="name">
      </mat-form-field>
      <tc-select-search placeholder="Select a category in the list or search category name"
          [readonly]="!canEdit"
          [ctrl]="productForm.controls.category_id"
          [items]="categories$ | async" bindValue="category_id" bindLabel="name"
          (change)="categoryChanged()"
          ></tc-select-search>
      <tc-select-search placeholder="Select a type in the list or search type name"
          [ctrl]="productForm.controls.type_id"
          [items]="selectableTypes$ | async" bindValue="type_id" bindLabel="name"
          ></tc-select-search>

      @if (productForm.controls.category_id.value === freightProductCategoryId) {
        <div>
          <mat-checkbox formControlName="unique_cost">
            Remove from Matched Offers
          </mat-checkbox>
        </div>
      }
    </div>

    <div [gdColumns]="'repeat(5, minmax(0, 1fr))' + (canEdit ? ' auto' : '')" gdGap="15px">
      @for (item of productForm.controls.overrides.controls; track item; let i = $index) {
        @if (!item.controls?.deleted?.value) {
          <tc-select-search placeholder="Select a company"
              [readonly]="!canEdit"
              [ctrl]="item.controls.account"
              [items]="selectableAccounts$ | async" bindValue="account" bindLabel="name">
              </tc-select-search>
          <tc-select-search placeholder="Select an item type"
            [readonly]="!canEdit"
              [ctrl]="item.controls.item_type_id"
              [items]="itemTypes$ | async" bindValue="item_type_id" bindLabel="name">
              </tc-select-search>
          <mat-form-field>
            <mat-label>Name override</mat-label>
            <input matInput type="text" autocomplete="off" [formControl]="item.controls.name">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Standard HS Code</mat-label>
            <input matInput type="text" autocomplete="off" readonly
              [value]="getStandardHsCode(item.controls.item_type_id.value)">
          </mat-form-field>
          <mat-form-field>
            <mat-label>HS Code override</mat-label>
            <input matInput type="text" autocomplete="off"
              [formControl]="item.controls.hs_code">
          </mat-form-field>
          @if (canEdit && !(inProgress$ | async)) {
            <i class="fa fa-minus-circle remove" (click)="markOverrideAsDeleted(item)"></i>
          }
        }
      }
      @if (canEdit) {
        <p class="text-right" gdColumn="span 6">
          <button type="button" class="btn btn-link modal-table-add" (click)="addOverrideRow()"
            [disabled]="inProgress$ | async">+ Add Override
          </button>
        </p>
      }
    </div>

    <div [gdColumns]="'repeat(2, minmax(0, 1fr))' + (canEdit ? ' auto' : '')" gdGap="15px">
      @for (item of productForm.controls.schedule_b_codes.controls; track item; let i = $index) {
        <tc-select-search placeholder="Select an item type"
            [readonly]="!canEdit"
            [ctrl]="item.controls.item_type_id"
            [items]="itemTypes$ | async" bindValue="item_type_id" bindLabel="name"
            ></tc-select-search>
        <mat-form-field>
          <mat-label>Schedule B code</mat-label>
          <input matInput type="text" autocomplete="off" [formControl]="item.controls.code">
        </mat-form-field>
        @if (canEdit && !(inProgress$ | async)) {
          <i class="fa fa-minus-circle remove" (click)="deleteScheduleBCode(i)"></i>
        }
      }
      @if (canEdit) {
        <p class="text-right" gdColumn="span 3">
          <button type="button" class="btn btn-link modal-table-add" (click)="addScheduleBCodeRow()" [disabled]="inProgress$ | async">+ Add Schedule B code</button>
        </p>
      }
    </div>
    <mat-checkbox [formControl]="productForm.controls.so_creation">
      Enable Supplier Offer Creation
    </mat-checkbox>
  </div>
  <mat-progress-bar [mode]="(inProgress$|async) ? 'indeterminate' : undefined"></mat-progress-bar>
  <div mat-dialog-actions align="end">
    <button mat-button type="button" mat-dialog-close>{{ canEdit ? 'Cancel' : 'Close' }}</button>
    @if (canEdit) {
      <button mat-raised-button type="button" color="primary" (click)="save()" [disabled]="inProgress$ | async">
        <i class="fa fa-save"></i> {{productForm.controls.product_id.value ? 'Update' : 'Save'}}
      </button>
    }
  </div>
</form>
